import { IN_HOUSE_REPORTS, MAIN_REPORTS, PRACTICE_REPORTS } from "../actions/types";

const initialState = {
  reportType: "main",
};

const reportsNavReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MAIN_REPORTS:
      return { ...state, reportType: "main" };
    case PRACTICE_REPORTS:
      return { ...state, reportType: "practice" };
    case IN_HOUSE_REPORTS:
      return { ...state, reportType: "in-house" };

    default:
      return state;
  }
};

export default reportsNavReducer;
